import React from 'react'
import { isNil } from 'lodash'

// styles
import {
  TableWrapper,
  TableHeader,
  TableCompanyInfoWrapper,
  TableCompanyInfoColumDescription,
  TableCompanyInfoColumAchievements,
  TableCompanyInfoColumResponsibilities,
  SkillsUsed,
  SkillsUsedWrapper,
  ProjectRole,
  TimeAsEmployee,
  Subtitle,
  TextDescription,
  EmployerDescription
} from './styles'
// utils
import { arrayToText, dateFormat, arrayWithObjectsToArray } from '../../utils/utils'
import PropTypes from 'prop-types'
import { Text } from '../../constants/TextConstants'

const printSkills = (info, SubTitle, printEmpty = false) => {
  if (printEmpty || info.length > 0) {
    return (
      <SkillsUsed>
        <Subtitle>{SubTitle}</Subtitle>
        <TextDescription>{arrayToText(info)}</TextDescription>
      </SkillsUsed>
    )
  } else {
    return <div />
  }
}

export const TableExperience = (props) => {
  return (
    <TableWrapper>
      <TableHeader>
        <Subtitle>Industry Sector:</Subtitle>
        <ProjectRole>{props.data.industry}</ProjectRole>
      </TableHeader>
      <TableHeader>
        <ProjectRole>{props.data.project_rol}</ProjectRole>
        <TimeAsEmployee>{dateFormat(props.data.ended_date, props.data.started_date)}</TimeAsEmployee>
      </TableHeader>
      <TableHeader>
        <Subtitle>Project Name:</Subtitle>
        <ProjectRole>{props.data.project_name}</ProjectRole>
        {!isNil(props.data.isEndavaExperience) && (
          <EmployerDescription>
            {props.data.isEndavaExperience ? Text.ExperienceEndava : Text.ExperienceExternal}
          </EmployerDescription>
        )}
      </TableHeader>
      <TableCompanyInfoWrapper>
        <TableCompanyInfoColumDescription>
          <Subtitle>{Text.ProjectDescription}:</Subtitle>
          <TextDescription>{props.data.description}</TextDescription>

          {
            props.data.additional_info_desc && props.data.additional_info_title &&
            <>
              <Subtitle>{props.data.additional_info_title[0].toUpperCase() + props.data.additional_info_title.slice(1)}:</Subtitle>
              <TextDescription>{props.data.additional_info_desc}</TextDescription>
            </>
          }

        </TableCompanyInfoColumDescription>
      </TableCompanyInfoWrapper>
      <TableCompanyInfoWrapper>
        <TableCompanyInfoColumAchievements>
          <Subtitle>{Text.Achievements}:</Subtitle>
          <TextDescription>{props.data.achievements}</TextDescription>
        </TableCompanyInfoColumAchievements>
        <TableCompanyInfoColumResponsibilities>
          <Subtitle>{Text.JobResponsibilities}:</Subtitle>
          <TextDescription>{props.data.responsabilities}</TextDescription>
        </TableCompanyInfoColumResponsibilities>
      </TableCompanyInfoWrapper>
      <SkillsUsedWrapper>
        {printSkills(arrayWithObjectsToArray(props.data.programming_languages, 'S'), 'Programming Languages', true)}
        {printSkills(arrayWithObjectsToArray(props.data.technologies_and_frameworks, 'S'), Text.Frameworks, true)}
        {printSkills(arrayWithObjectsToArray(props.data.testing_and_development_tools, 'S'), Text.Testing, true)}
      </SkillsUsedWrapper>
    </TableWrapper>
  )
}

TableExperience.propTypes = {
  data: PropTypes.object
}
